import { createUseData } from "../../../common/hooks/create-use-data/create-use-data";
import { service } from "./reset-password.service";

export const useValidateResetPasswordToken = createUseData(
    (token: string) => service.validateToken(token)
)